import * as img from './imageTools'
import * as pdf from './pdfTools'
import * as office from './officeTools'

// Maps a tool id to an async runner: (files, opts) => result.
// result: { blob, name, mime, pages?, multiOut?, note? }
const RUNNERS = {
  compress: (f, o) => img.compressImage(f[0], o),
  resize: (f, o) => img.resizeImage(f[0], o),
  crop: (f, o) => img.cropImage(f[0], o),
  convert: (f, o) => img.convertImage(f[0], o),
  removebg: (f, o) => img.removeBackground(f[0], o),
  blurface: (f, o) => img.blurRegions(f[0], o),
  rotate: (f, o) => img.rotateImage(f[0], o),
  upscale: (f, o) => img.upscaleImage(f[0], o),
  watermark: (f, o) => img.watermarkImage(f[0], o),
  img2pdf: (f, o) => img.imagesToPdf(f, o),

  merge: (f) => pdf.mergePdfs(f),
  split: (f, o) => pdf.splitPdf(f[0], o),
  compresspdf: (f, o) => pdf.compressPdf(f[0], o),
  pdf2word: (f) => pdf.pdfToWord(f[0]),
  word2pdf: (f) => pdf.wordToPdf(f[0]),
  pdf2ppt: (f) => office.pdfToPpt(f[0]),
  ppt2pdf: (f) => office.pptToPdf(f[0]),
  pdf2excel: (f) => office.pdfToExcel(f[0]),
  excel2pdf: (f) => office.excelToPdf(f[0]),
  pdf2jpg: (f, o) => pdf.pdfToImages(f[0], o),
  editpdf: (f, o) => pdf.editPdf(f[0], o),
  sign: (f, o) => pdf.signPdf(f[0], o),
  protect: (f, o) => pdf.protectPdf(f[0], o),
  unlock: (f, o) => pdf.unlockPdf(f[0], o),
  wmpdf: (f, o) => pdf.watermarkPdf(f[0], o),
  rotatepdf: (f, o) => pdf.rotatePdf(f[0], o),
  pagenum: (f, o) => pdf.addPageNumbers(f[0], o),
}

export async function runTool(id, files, opts) {
  const runner = RUNNERS[id]
  if (!runner) throw new Error('This tool is not available yet.')
  return runner(files, opts)
}
